import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { CheckDuplicateGroupCodeQuery, GroupApi } from 'api';

export const findCustomerGroupsWithEntity = createAsyncThunk(
  'entityGroup/findCustomerGroupsWithEntity',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await GroupApi.findCustomerGroup(option);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findSupplierGroupsWithEntity = createAsyncThunk(
  'entityGroup/findSupplierGroupsWithEntity',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await GroupApi.findSupplierGroup(option);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const checkDuplicateGroupCode = createAsyncThunk(
  'entityGroup/checkDuplicateGroupCode',
  async (query: CheckDuplicateGroupCodeQuery, { rejectWithValue }) => {
    try {
      const response = await GroupApi.checkDuplicate(query);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const generateGroupCode = createAsyncThunk(
  'entityGroup/generateGroupCode',
  async (query: any, { rejectWithValue }) => {
    try {
      const response = await GroupApi.generateCode(query);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createCustomerGroup = createAsyncThunk(
  'entityGroup/createCustomerGroup',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await GroupApi.createCustomerGroup(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createSupplierGroup = createAsyncThunk(
  'entityGroup/createSupplierGroup',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await GroupApi.createSupplierGroup(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  tableList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
  savedPagination: any;
  savedList: Array<any>;
}

const initialState: IState = {
  tableList: [],
  list: [],
  reloadFlag: false,
  savedPagination: { current: 1, next: 2, prev: 0, take: 10, total: 0 },
  savedList: [],
};

const entityGroupSlice = createSlice({
  name: 'entityGroup',
  initialState,
  reducers: {
    reloadEntityGroup(state) {
      state.reloadFlag = !state.reloadFlag;
    },
    updateSavedPaginationEntityGroup(state, action) {
      state.savedPagination = action.payload;
    },
    updateSavedListEntityGroup(state, action) {
      state.savedList = action.payload;
    },
  },
});

const { actions, reducer: entityGroupReducer } = entityGroupSlice;

export const {
  reloadEntityGroup,
  updateSavedPaginationEntityGroup,
  updateSavedListEntityGroup,
} = actions;

export default entityGroupReducer;
